'use strict';

import { createConnector } from 'react-instantsearch';
import { buildCourseStatusFilter, CourseStatus, getUserCourses } from './course-status';

const applyStatus = (searchState, status) => {
	const { course_status, ...rest } = searchState;
	
	return CourseStatus.All === status
		? { ...rest, page: 1 }
		: { ...rest, course_status: status, page: 1 };
};

/**
 * react-instantsearch v5 doesn't provide a structured contract for these
 * connector methods. See the built-in connectors for methods and parameters.
 *
 * @see connectHierarchicalMenu
 * @see connectPagination
 * @see connectRefinementList
 * @see connectToggleRefinement
 */
export const connector = {
	displayName: 'CourseStatus',
	
	getProvidedProps(props, searchState) {
		const { completed_ids, in_progress_ids } = getUserCourses();
		
		return {
			current_refinement: searchState.course_status,
			has_in_progress: in_progress_ids.length > 0,
			has_completed: completed_ids.length > 0,
		};
	},
	
	refine(props, searchState, status) {
		return applyStatus(searchState, status);
	},
	
	cleanUp(props, searchState) {
		const { course_status, ...rest } = searchState;
		
		return rest;
	},
	
	getSearchParameters(searchParameters, props, searchState) {
		const filters = buildCourseStatusFilter(searchState.course_status);
		
		return filters
			? searchParameters.setQueryParameter('filters', filters)
			: searchParameters;
	},
	
	getMetadata(props, searchState) {
		const status = searchState.course_status;
		
		return {
			id: 'course_status',
			items: status ? [
				{
					attribute: 'course_status',
					label: status,
					currentRefinement: status,
					value: (searchState) => applyStatus(searchState, CourseStatus.All),
				}
			] : [],
		};
	},
};

export default createConnector(connector);
